import { AliceApp } from 'client/model/skill';
import { v4 as uuidv4 } from 'uuid';

import { Operation, OperationEvent, OperationType } from '../model/operation';

interface CreateOperationParams {
    aliceApp: AliceApp;
    type: OperationType;
}

export const createOperation = ({ aliceApp, type }: CreateOperationParams): Operation => {
    return {
        comment: '',
        createdAt: new Date().toJSON(),
        itemId: aliceApp.id,
        itemName: aliceApp.name,
        type,
        id: uuidv4(),
    };
};

export const sortEventsByDate = (aEvent: OperationEvent, bEvent: OperationEvent) => {
    if (aEvent?.operation?.createdAt > bEvent?.operation?.createdAt) {
        return -1;
    }
    if (bEvent?.operation?.createdAt > aEvent?.operation?.createdAt) {
        return 1;
    }
    return 0;
};
